// ✅ TIPOS MÁS ESPECÍFICOS Y CONSISTENTES
export interface Business {
  id: number;
  name: string;
  // Agregar más campos según necesidad
}

export interface RegisterOut {
  id: number;
  user_id: number;
  fatigue: number;
  pain: number;
  venom?: boolean;
  cryotherapy?: boolean;
  pressotherapy?: boolean;
  massage_gun?: boolean;
  created_at: string;
}

export interface Saved {
  id: number;
  protocol_id: number;
  user_id: number;
}

// ✅ ENUM PARA MODOS DE USUARIO
export enum UserMode {
  VIEWER = 'viewer',
  ACTIVE_IN = 'active-in',
  ACTIVE_OUT = 'active-out',
}

export interface UserState {
  id?: number;
  email?: string;
  rut?: string;
  password?: string;
  first_name?: string;
  last_name?: string;
  height?: number;
  weight?: number;
  birthday?: string;
  sex?: string;
  diabetes?: boolean;
  heart_diseases?: boolean;
  other_diseases?: string;
  thrombosis?: boolean;
  business_id?: number;
  token?: string;
  business?: Business;
  saveds?: Saved[];
  registerOuts?: RegisterOut[];
  redirect?: string;
  mode?: UserMode;
  started?: string;
}

// ✅ TIPOS PARA FORMULARIOS MÁS ESPECÍFICOS
export interface UserPostFields {
  email: string;
  rut: string;
  password: string;
  first_name: string;
  last_name: string;
  height: number;
  weight: number;
  birthday: string;
  sex: string;
  diabetes: boolean;
  heart_diseases: boolean;
  other_diseases: string;
  thrombosis: boolean;
  business_id: number;
  phone: string;
}

export interface UserAuthFields {
  email: string;
  password: string;
}

// ✅ TIPOS PARA RESPUESTAS DE API
export interface UserResponse {
  user: UserState;
  token: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}
